<template>
  <v-card v-if="currentCoin" class="gray10 h-100">
    <template v-if="!globalSetting.useNewChart">
      <v-tabs v-model="tab" background-color="transparent" class="mt-3">
        <v-tab
          v-for="(item, index) in chartTypeTab"
          :key="index"
          :href="'#' + item.value"
        >
          <span class="font-Medium-14">
            {{ item.title }}
          </span>
        </v-tab>
        <div
          class="button-controls"
          v-if="currentCoin && tab === 'trading-view' && isAuth"
        >
          <v-btn
            color="primary"
            @click="setIndicators"
            class="btn btn-secondary elevation-0 mt-4 me-4 save-chart-btn"
          >
            <v-icon
              v-if="$vuetify.breakpoint.smAndDown"
              clr="var(--v-gray2-base)"
              >$floppySave</v-icon
            >
            <span v-else>{{ $t("exchange.saveChart") }}</span>
          </v-btn>
        </div>
      </v-tabs>
    </template>
    <v-row class="mb-2 charts-wrapper pa-4">
      <v-col v-if="!loading" cols="12" class="local-tradingview">
        <template v-if="tab === 'trading-view'">
          <LocalTradingviewNew
            v-if="globalSetting.useNewChart"
            :key="currentCoin.symbol"
            :symbol="currentCoin.symbol"
            :coinScale="currentCoin.frontBaseCoinScale"
            :chartTypeTab="chartTypeTab"
            :selectedChartTypeTab="tab"
            @changeTab="changeTab"
          />
          <localTradingView
            v-else
            :key="currentCoin.symbol"
            :currentCoin="currentCoin"
            ref="localTradingView"
          />
        </template>
        <global-trading-view
          v-if="
            currentCoin &&
              currentCoin.baseSymbol !== 'IRR' &&
              tab === 'global-chart'
          "
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
        />
        <depth-graph
          v-if="currentCoin && tab === 'depth'"
          :current-coin="currentCoin"
          :key="currentCoin.symbol"
          :chartTypeTab="chartTypeTab"
          :selectedChartTypeTab="tab"
          @changeTab="changeTab"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import localTradingView from "@/components/Market/exchange/tradeCharts/localTradingView.vue";
import LocalTradingviewNew from "@/components/Market/exchange/tradeCharts/localTradingViewNew.vue";

import { ExchangeService } from "@/services";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import GlobalTradingView from "@/components/Market/exchange/tradeCharts/globalTradingView.vue";
import DepthGraph from "@/components/Market/exchange/tradeCharts/depthGraph.vue";
import { authMixin } from "@/mixins/authMixin";

export default {
  name: "index",
  mixins: [authMixin],
  components: {
    DepthGraph,
    GlobalTradingView,
    localTradingView,
    LocalTradingviewNew,
  },
  computed: {
    ...mapGetters({
      currentCoin: types.marketExchange.getters.GET_CURRENT_COIN,
    }),

    chartTypeTab() {
      const types = [
        {
          title: this.$t("exchange.excoinoMarketChart"),
          value: "trading-view",
        },
        { title: this.$t("exchange.depth"), value: "depth" },
      ];
      // if (
      //   this.currentCoin.baseSymbol !== "IRR" &&
      //   !this.currentCoin.baseSymbol.startsWith("V-")
      // ) {
      //   types.push({
      //     title: this.$t("exchange.globalChart"),
      //     value: "global-chart"
      //   });
      // }

      return types;
    },
  },
  data() {
    return {
      tab: "trading-view",
      globalSetting: {},
      loading: true,
    };
  },
  methods: {
    setIndicators() {
      this.$refs.localTradingView.setIndicators();
    },
    getGlobalSetting() {
      this.loading = true;
      ExchangeService.getGlobalConfig()
        .then((res) => {
          this.globalSetting = res.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    changeTab(tabValue) {
      this.tab = tabValue;
    },
  },

  mounted() {
    this.getGlobalSetting();
  },
};
</script>
<style lang="scss">
.charts-wrapper {
  background: var(--v-gray1) !important;
  height: 100%;
  min-height: 700px;
  .chart-loader {
    position: absolute;
    left: 50%;
  }
}

.local-tradingview {
  height: 100%;
  max-height: 800px;
  position: relative;
  overflow: hidden;

  @media (max-width: 960px) {
    height: 800px !important;
  }

  #chart_wrapper {
    height: 100%;
    width: 100%;

    #tv_chart_container {
      height: calc(100% - 40px);
      width: 100%;
      iframe {
        height: 100% !important;
      }
    }
  }

  .local-tradingview-in {
    position: absolute;
    top: 5px;
    right: 40px;
    z-index: 1;

    .local-tradingview-in-btn {
      border-radius: 0 !important;
    }
  }
}

.global-tradingview {
  height: 100%;
  position: relative;
  overflow: hidden;

  .tradingview-widget-container {
    height: 100%;

    .trading-view-in {
      height: 100%;
    }
  }

  .local-tradingview-in {
    position: absolute;
    top: 5px;
    right: 40px;
    z-index: 1;

    .local-tradingview-in-btn {
      border-radius: 0 !important;
    }
  }
}

.trade_wrap {
  position: relative;

  .trade_menu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #27313e;
    height: 40px;
    line-height: 39px;

    @media (max-width: 700px) {
      height: 50px;
      overflow-x: auto;
    }

    > span {
      min-width: 140px;
      cursor: pointer;

      &.active {
        background-color: #27313e;
        border-bottom: 1px solid #f0a70a;
      }

      @media (max-width: 576px) {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .info-modal-button {
      display: flex;
      cursor: pointer;
    }
  }

  .trade-type {
    display: none;
    justify-content: center;
    align-items: center;

    .trade-type-buy,
    .trade-type-sell {
      position: relative;
      width: 50%;
      height: 30px;
      line-height: 30px;
    }

    .trade-type-sell {
      background-color: #f15050;
      cursor: pointer;

      &:hover {
        background-color: #f1505f;

        &:after {
          border-right: 15px solid #f1505f;
          border-top: 15px solid transparent;
          border-bottom: 15px solid transparent;
        }
      }

      &:after {
        position: absolute;
        content: "";
        border-right: 15px solid #f1505f;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        top: 0;
        left: -14px;
        z-index: 2;
      }
    }

    .trade-type-buy {
      background-color: #00b270;
      cursor: pointer;
      z-index: 1;

      &:hover {
        background-color: #00b27f;
      }
    }
  }

  .mask {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 110;
    color: #ffffff;
  }

  .publish-mask {
    position: absolute;
    height: 100%;
    background-color: rgba(27, 35, 47, 0.95);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 109;
  }
}

.change-tradingview-chart {
  min-width: 120px;
  border-radius: 0;
}

@media (max-width: 800px) {
  .trade_wrap {
    .trade-type {
      display: flex !important;
    }
  }
}

@media (max-width: 576px) {
  .exchange {
    .trade_wrap .trade_menu {
      & > span {
        @media (min-width: 576px) {
          min-width: 33.33333%;
        }
      }
    }
  }
}

#kline_container {
  background: var(--v-gray1);
}
.save-chart-btn {
  position: absolute;
  left: 0;
  top: -16px;
}

.options {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px;
  width: 100%;
  background: var(--v-gray8-base);
  border-bottom: 1px solid var(--v-gray4-base);
  border-radius: 10px 10px 0 0;
  &-item {
    color: var(--v-gray2-base);
    cursor: pointer;
    transition: all 300ms;
    margin: 0 4px;
    font-size: 12px;
    &:hover {
      color: var(--v-primary-base);
    }
  }
}
</style>
